<template>
  <div>
    <el-dialog
      title="Yeni sənəd"
      :visible.sync="showModal"
      width="40%"
      top="5vh"
      append-to-body
      :close-on-press-escape="false" 
      :close-on-click-modal="false" 
    >
      <el-form
        ref="policy"
        :model="item"
        label-width="120px"
        :label-position="labelPosition"
        size="small"
        v-loading="loading"
      >
        <div class="row">
          <div class="col-12">
            <el-form-item :label="$t('Sığorta_növü')" prop="insuranceType">
              <el-select
                style="width: 90%"
                @input="inputInsuranceType"
                :placeholder="$t('Seçin')"
                size="small"
                v-model="item.insuranceType"
                @change="changed"
              >
                <el-option
                  label="İcbari avto məsuliyyət"
                  :value="1"
                ></el-option>
                <el-option label="Kasko" :value="2"></el-option>
                <el-option :label="$t('Əmlak')" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <el-form-item label="Sənəd növü" prop="claimDocTmplId">
              <el-select
                style="width: 90%"
                :placeholder="$t('Seçin')"
                filterable
                :value="item.claimDocTmplId"
                @input="inputClaimDocTmpl"
              >
                <el-option
                  v-for="item in claimDocsTmpl"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  size="small" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ClaimDocType } from "../../services/types";
import { GetClaimDocTmpl } from "../../services/cls";
import { CreateClaimDoc } from "src/services/claim";
import { labelPosition } from "../../services/helper";

export default {
  data() {
    return {
      activeName: "person",
      showModal: false,
      mode: "",
      loading: false,
      item: {},
      claimDocsTmpl: [],
      uid: this.$store.state.user.id,
      labelPosition: labelPosition,
    };
  },
  methods: {
    new(claimId) {
      this.activeName = "claimdoc";
      this.item = new ClaimDocType();
      this.item.claimId = claimId;
      this.mode = "New";
      this.showModal = true;
    },
    clickSave() {
      this.loading = true;
      let docs = Object.assign({}, this.item);
      docs.commandUserId = this.uid;
      if (this.mode === "New") {
        CreateClaimDoc(docs).then((response) => {
          this.loading = false;
          if (response.data.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0],
              });
            } else {
              this.$emit("saved", { action: "new", id: response.data.data.value });
              this.showModal = false;
              this.$message({
                type: "success",
                message: "Uğurlu əməliyyat",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        });
      }
    },
    inputInsuranceType(e) {
      this.$emit("input", e);
      this.item.insuranceType = e;
    },
    inputClaimDocTmpl(e) {
      this.$emit("input", e);
      this.item.claimDocTmplId = e;
    },
    changed() {
      this.getClaimDocTmpl();
    },
    getClaimDocTmpl() {
      GetClaimDocTmpl(this.item.insuranceType).then((response) => {
        if (response.data.data) {
          this.claimDocsTmpl = response.data.data;
        } else {
          this.$message({
            type: "error",
            message: "Claim docs: No data found!",
          });
        }
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>
